import domReady from '@wordpress/dom-ready';

let ELEMENT;
const EVENTS = Object.freeze({
  keyup: 'keynav-active',
  mousemove: 'mousenav-active',
  touchstart: 'touchnav-active',
});

/**
 * initialize the navigation detection
 */
function init() {
  ELEMENT = document.getElementsByTagName('html')[0];
  bindEventListeners();
}

/**
 * Helper to add or remove the event listeners
 */
function bindEventListeners() {
  for (const eventType of Object.keys(EVENTS)) {
    ELEMENT.addEventListener(eventType, updateClassName);
  }
}

/**
 * Add appropriate html classes based on navigation method
 *
 * @param {object} e - event
 */
function updateClassName(e) {
  // we are only concerned with "tab" on keyup
  if (e.type === 'keyup' && e.which !== 9) return;

  ELEMENT.removeEventListener(e.type, updateClassName);

  ELEMENT.classList.add(EVENTS[e.type]);
}

domReady(init);
